// src/components/blogs/BlogListItem.jsx
import React from 'react'
import { KTSVG } from '../../../_metronic/helpers'

const BlogListItem = ({ item, viewDetails, editBlog, deleteBlog }) => {
    return (
        <tr key={item._id}>
            <td></td>
            <td>{item?.title}</td>
            <td>{item?.metaTitle}</td>
            <td>{item?.meta_keywords}</td>
            <td>
                <span className={`badge badge-light-${item?.status === 1 ? 'success' : 'danger'} badge-inline`}>
                    {item?.status === 1 ? 'Active' : 'Inactive'}
                </span>
            </td>
            <td className="">
                <div className="d-flex flex-shrink-0">
                    <button
                        onClick={() => viewDetails(item?._id)}
                        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                        title="View Details"
                    >
                        <KTSVG path="/media/icons/duotune/general/gen028.svg" className="svg-icon-3 text-primary" />
                    </button>
                    <button
                        onClick={() => editBlog(item._id)}
                        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                    >
                        <KTSVG path="/media/icons/duotune/art/art005.svg" className="svg-icon-3 text-primary" />
                    </button>
                    <button
                        onClick={() => deleteBlog(item._id)}
                        className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                    >
                        <KTSVG
                            path="/media/icons/duotune/general/gen027.svg"
                            className="svg-icon-3 text-primary text-white"
                        />
                    </button>
                </div>
            </td>
        </tr>
    )
}

export default BlogListItem
